import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import MoneyPersonalityBox from '../../components/MoneyPersonalityBox';

const MoneyPersonalityPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#F6F4FF] p-4">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <Link
            to="/insights/income-gap"
            className="inline-flex items-center text-[#221A51] hover:text-[#221A51]/80 mb-4"
          >
            <ArrowLeftIcon className="w-5 h-5 mr-2" />
            Back to Insights
          </Link>
          <h1 className="text-3xl font-bold text-[#221A51] mb-2">Your Money Personality</h1>
          <p className="text-[#221A51]/60">
            Based on your spending patterns, we've analyzed your financial zodiac
          </p>
        </div>

        {/* Reuse existing MoneyPersonalityBox */}
        <div className="mb-8">
          <MoneyPersonalityBox />
        </div>

        {/* Additional Content */}
        <div className="grid gap-6">
          <div className="bg-white rounded-xl p-6 border-2 border-[#221A51] shadow-[4px_4px_0px_0px_#221A51]">
            <h3 className="text-xl font-bold text-[#221A51] mb-4">What This Means</h3>
            <p className="text-[#221A51]/80">
              Your money personality is a fun way to look at your spending habits. While it's not scientific,
              it can help you understand your financial tendencies and make better decisions.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 border-2 border-[#221A51] shadow-[4px_4px_0px_0px_#221A51]">
            <h3 className="text-xl font-bold text-[#221A51] mb-4">Tips for Growth</h3>
            <ul className="space-y-2">
              <li className="flex items-start">
                <span className="text-[#9B86EA] mr-2">•</span>
                <span className="text-[#221A51]">Track your spending regularly</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#9B86EA] mr-2">•</span>
                <span className="text-[#221A51]">Set clear financial goals</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#9B86EA] mr-2">•</span>
                <span className="text-[#221A51]">Build an emergency fund</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Share Button */}
        <div className="mt-8 text-center">
          <button
            onClick={() => {
              const text = "Check out my Money Personality on Money Wrapped!";
              if (navigator.share) {
                navigator.share({
                  text: text,
                  title: 'My Money Personality',
                });
              } else {
                navigator.clipboard.writeText(text);
              }
            }}
            className="bg-[#9B86EA] text-white px-6 py-3 rounded-xl font-medium
                     border-2 border-[#221A51] shadow-brutal
                     hover:shadow-[6px_6px_0px_0px_#221A51] hover:translate-x-[-2px] hover:translate-y-[-2px]
                     active:translate-x-[2px] active:translate-y-[2px] active:shadow-[2px_2px_0px_0px_#221A51]
                     transition-all duration-200"
          >
            Share Your Personality
          </button>
        </div>
      </div>
    </div>
  );
};

export default MoneyPersonalityPage;
